import { AbstractControl, ValidatorFn } from '@angular/forms';

export function TrimValidator(): ValidatorFn {
    return (control: AbstractControl): Record<string, unknown> | null => {
        if (control.value?.startsWith(' ')) {
            return {
                trimError: { value: 'control has leading whitespace' },
            };
        }
        if (control.value?.endsWith(' ')) {
            return {
                trimError: { value: 'control has trailing whitespace' },
            };
        }
        return null;
    };
}
